import { render, staticRenderFns } from "./ConnectMsg.vue?vue&type=template&id=29cbc9f0&lang=pug&"
import script from "./ConnectMsg.vue?vue&type=script&lang=js&"
export * from "./ConnectMsg.vue?vue&type=script&lang=js&"
import style0 from "./ConnectMsg.vue?vue&type=style&index=0&id=29cbc9f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports